import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RequestService } from 'src/app/shared/services/request/request.service';

@Injectable({
  providedIn: 'root',
})
export class FiltrosRegioesService {
  constructor(private _requestService: RequestService) {}

  listState(regionID: number): Observable<any> {
    return this._requestService.requestMethod(
      `work/Metrics/State?regionID=${regionID}`,
      'GET',
      true,
      null
    );
  }

  listCities(stateID: number): Observable<any> {
    return this._requestService.requestMethod(
      `work/Metrics/City?stateID=${stateID}`,
      'GET',
      true,
      null
    );
  }

  listRegions(): Observable<any> {
    return this._requestService.requestMethod(
      `work/Metrics/Region`,
      'GET',
      true,
      null
    );
  }
}
